// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1k3DN","inputDescription":"styles_inputDescription__ASYyb"};